import { PropsWithChildren } from 'react';
import { AnalyticsProvider } from '@3plearning/mx-teacher-analytics/react';

import { analyticsClient } from './analytics-client';

export function AnalyticsAppProvider({ children }: PropsWithChildren<unknown>) {
    return (
        <AnalyticsProvider client={analyticsClient}>
            {children}
        </AnalyticsProvider>
    );
}
